export const CLASSROOM_DATA_PAGE = {
  content: "Classroom data",
  id: "classroom-data",
  url: "/reports/teacher/classroom-data/",
};

export const STUDENT_DATA_PAGE = {
  content: "Student data",
  id: "student-data",
  url: "/reports/teacher/student-data/",
};

export const CLASSROOM_POWER_WORDS_PAGE = {
  content: "Power words",
  id: "power-words",
  url: "/reports/teacher/power-words/",
};

export const STUDENT_POWER_WORDS_PAGE = {
  content: "Student power words",
  id: "student-power-words",
  url: "/reports/teacher/power-words/student/",
};

export const STUDENT_MY_PROGRESS_PAGE = {
  content: "My progress",
  id: "student-my-progress",
  url: "/reports/student/my-progress/",
};

export const USAGE_REPORT_PAGE = {
  content: "Usage report",
  id: "usage-report",
  url: "/reports/admin/usage-report/",
};

export const USAGE_REPORT_SCHOOL_DATA_PAGE = {
  content: "School data",
  id: "school-data",
  url: "/reports/admin/usage-report/school-data/",
};

export const USAGE_REPORT_TEACHER_DATA_PAGE = {
  content: "Teacher data",
  id: "teacher-data",
  url: "/reports/admin/usage-report/teacher-data/",
};

export const ADMIN_STANDARDS_REPORT_PAGE = {
  content: "Standards report",
  id: "standards-report",
  url: "/reports/admin/standards-report/",
};

export const ADMIN_WRITING_REPORT_PAGE = {
  content: "Writing report",
  id: "writing-report",
  url: "/reports/admin/writing-report/",
};
